import React from 'react';
import { connect } from 'react-redux';
import { currentOpeningsConfig } from '../../entity/Jobs/currentOpeningsConfig';
import MasterComponent from '../../components/Forms';
import { MasterConfigs } from '../../interfaces/entity';
import { Typography } from 'antd';
import { encryptData } from '../../actions/crypto';
const { Paragraph, Text } = Typography;
const CurrentOpenings = () => {

  const overRide: MasterConfigs = {
    ...currentOpeningsConfig,
    getColumns: () => [
      ...currentOpeningsConfig.getColumns(),
      {
        title: 'JobLink',
        dataIndex: '',
        render: (text) => <Paragraph
          ellipsis={{
            rows: 1,
            expandable: 'collapsible',
          }}
          copyable={{ text: process.env.CRM_URL + '/apply/' + text.jobId }}>{process.env.CRM_URL}/apply/{text.jobId}</Paragraph>

      }
    ]
  }

  return <>
    <MasterComponent config={overRide} />
  </>
}


const mapStateToProps = (state) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

export default connect(mapStateToProps)(CurrentOpenings);

